import * as React from "react";
import { IssueStatus } from "@adsk/acc-issues-types";
import { StatusDropdown } from "@adsk/acc-issues-common/components/input/StatusDropdown";
import { CompactEditableFieldWrapper } from "@adsk/acc-issues-common/components/primitive/EditableFieldWrapper";
import { StatusDisplay } from "@adsk/acc-issues-common/components/display/StatusDisplay";
import { useFieldTestId } from "../../../utils/components/IssueFieldPresentationContext";
import { DefaultEditFieldInterface } from "./typesForFields";
import { isAttributeEditable } from "../../../utils/data/entityPermissions";
import { StatusFieldLabel } from "../StatusFieldLabel";
import { useTranslations } from "@adsk/acc-issues-translations";

// This Field is similar to the one in IssuesTab/TemplatesConfig/IssueTemplateDetailPanel/detail-panel-fields/IssueStatusField.tsx
// In case any necessary change is needed, it would be nice check on the other file as well
export const StatusField = ({
  issue,
  onChange,
  containerRef,
  isDisabledDueToRequiredFields = false,
  viewOnly = false,
}: DefaultEditFieldInterface & {
  isDisabledDueToRequiredFields?: boolean;
  viewOnly?: boolean;
}) => {
  const { T } = useTranslations();
  const testId = useFieldTestId("status-field");
  const isDisabled =
    viewOnly ||
    !isAttributeEditable(issue, "status") ||
    isDisabledDueToRequiredFields;
  const fieldLabel = <StatusFieldLabel />;
  return (
    <div data-testid={testId}>
      <CompactEditableFieldWrapper
        testId={testId}
        fieldKey="status"
        label={fieldLabel}
        value={issue.status}
        renderValue={value => {
          return value ? <StatusDisplay status={value} /> : null;
        }}
        disabled={isDisabled}
        disabledReason={
          isDisabledDueToRequiredFields
            ? T.translate(
                "issueEditForm.status.disabledDueToRequiredFieldsTooltip"
              )
            : undefined
        }
        showDisabledReason={!viewOnly}
        containerRef={containerRef}
        renderInput={({ value, onChange: inlineEditOnChange }) => {
          return (
            <StatusDropdown
              // right now status is marked as optional in the sdk for issue -- is that actually true?
              // my understanding is that status is one of the few required fields...
              // for now, default to showing "undefined" as Open
              status={issue.status || IssueStatus.Open}
              onChange={(newStatus: IssueStatus) => {
                inlineEditOnChange(newStatus);
                onChange({
                  status: newStatus,
                });
              }}
              defaultIsOpen={true}
              onClose={() => inlineEditOnChange(value)}
              statusOptions={issue.permittedStatuses}
            />
          );
        }}
      />
    </div>
  );
};
